import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import TextArea from 'component/utils/TextArea'
import SelectType from 'component/utils/SelectType'
import { PARAMETER_TYPE, STATUS_TYPE_INVERTED } from 'constants/config'

class ParameterModalEditForm extends Component {
  componentDidMount() {
    const { setValueToField, initialValues } = this.props

    setValueToField('nuParameter', initialValues.nuParameter)
  }

  handleChange = (event) => {
    const { name, value } = event.target
    const { fields, setValueToField } = this.props

    setValueToField(name, value)
    fields[name].input.onChange(event)
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const { onSubmit, values } = this.props

    onSubmit(values)
  }

  render() {
    const { translate, fields, closeModal, disabled, initialValues } =
      this.props

    return (
      <Modal closeModal={closeModal} size='lg'>
        <Row>
          <Col xs={12}>
            <legend className='margin-top margin-bottom'>
              {translate('parameters.edit-parameters')}
            </legend>
          </Col>
        </Row>

        <form onSubmit={this.handleSubmit}>
          <Row className='margin-bottom'>
            <Col md={2} xs={12}>
              <Field
                {...fields.idBranch}
                error={translate(fields.idBranch.error)}
              >
                <Input
                  id='idBranch'
                  {...fields.idBranch.input}
                  label={translate('parameters.idBranch')}
                  onChange={this.handleChange}
                  disabled
                />
              </Field>
            </Col>

            <Col md={3} xs={12}>
              <Field
                {...fields.nuParameter}
                error={translate(fields.nuParameter.error)}
              >
                <Input
                  id='nuParameter'
                  {...fields.nuParameter.input}
                  label={translate('parameters.nuParameter')}
                  onChange={this.handleChange}
                  disabled
                />
              </Field>
            </Col>

            <Col md={3} xs={12}>
              <Field
                {...fields.inInactive}
                error={translate(fields.inInactive.error)}
                className='no-margin'
              >
                <SelectType
                  {...fields.inInactive.input}
                  id='inInactive'
                  name='inInactive'
                  options={STATUS_TYPE_INVERTED}
                  translate={translate}
                  onChange={this.handleChange}
                  disabled
                  value={initialValues.inInactive}
                />
              </Field>
            </Col>

            <Col md={4} xs={12}>
              <Field
                {...fields.tpValue}
                error={translate(fields.tpValue.error)}
                className='no-margin'
              >
                <SelectType
                  {...fields.tpValue.input}
                  id='tpValue'
                  name='tpValue'
                  options={PARAMETER_TYPE}
                  translate={translate}
                  onChange={this.handleChange}
                  label={translate('parameters.tpValue')}
                  disabled
                  value={initialValues.tpValue}
                />
              </Field>
            </Col>
          </Row>

          <Row className='margin-bottom'>
            <Col xs={12}>
              <Field {...fields.dsKey} error={translate(fields.dsKey.error)}>
                <Input
                  id='dsKey'
                  {...fields.dsKey.input}
                  label={translate('parameters.dsKey')}
                  onChange={this.handleChange}
                  disabled
                />
              </Field>
            </Col>
          </Row>

          <Row className='margin-bottom'>
            <Col xs={12}>
              <Field
                {...fields.dsValue}
                error={translate(fields.dsValue.error)}
              >
                <TextArea
                  type='textarea'
                  id='dsValue'
                  name='dsValue'
                  {...fields.dsValue.input}
                  label={translate('parameters.dsValue')}
                  onChange={this.handleChange}
                  rows={6}
                  disabled={disabled}
                />
              </Field>
            </Col>
          </Row>

          <Row className='margin-bottom'>
            <Col xs={12}>
              <Field
                {...fields.teValue}
                error={translate(fields.teValue.error)}
              >
                <Input
                  id='teValue'
                  {...fields.teValue.input}
                  label={translate('parameters.teValue')}
                  onChange={this.handleChange}
                  disabled
                />
              </Field>
            </Col>
          </Row>

          <Row className='margin-bottom'>
            <Col xs={12}>
              <Field
                {...fields.dsParameter}
                error={translate(fields.dsParameter.error)}
              >
                <Input
                  id='dsParameter'
                  {...fields.dsParameter.input}
                  label={translate('parameters.dsParameter')}
                  onChange={this.handleChange}
                  disabled
                />
              </Field>
            </Col>
          </Row>

          <Row className='margin-bottom'>
            <Col xs={12}>
              <Field
                {...fields.dsDocument}
                error={translate(fields.dsDocument.error)}
              >
                <Input
                  id='dsDocument'
                  {...fields.dsDocument.input}
                  label={translate('parameters.dsDocument')}
                  onChange={this.handleChange}
                  disabled
                />
              </Field>
            </Col>
          </Row>

          <Row className='margin-top-double margin-bottom'>
            <Col md={6} xs={6}>
              <button
                type='button'
                className='button-hollow button-hollow-danger button-full align-center'
                onClick={closeModal}
              >
                {translate('cancel_button_label')}
              </button>
            </Col>

            {!disabled && (
              <Col md={6} xs={6}>
                <button
                  type='submit'
                  className='button button-primary button-full'
                >
                  {translate('save_button_label')}
                </button>
              </Col>
            )}
          </Row>
        </form>
      </Modal>
    )
  }
}

ParameterModalEditForm.propTypes = {
  translate: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
}

const fields = [
  'idBranch',
  'dsKey',
  'nuParameter',
  'dsParameter',
  'dsDocument',
  'tpValue',
  'dsValue',
  'teValue',
  'inInactive',
]

export default Form({ fields })(ParameterModalEditForm)

export { ParameterModalEditForm }
